import { Button } from '@design/components/button/Button';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { formatWebsiteInfo, WebsiteInfo } from '../utils/formatWebsiteInfo';
import { parseLinks } from '../utils/normalizeUrl';
import { useRows } from '../utils/useRows';
import styles from './LinkInput.module.scss';
import { MAX_CUSTOM_SOURCES } from './SourcesDroppableArea';

interface LinkInputProps {
  sourceCount: number;
  handleAddWebsites: (websites: WebsiteInfo[]) => void;
}

export const LinkInput = ({
  sourceCount,
  handleAddWebsites,
}: LinkInputProps) => {
  const { t } = useTranslation(['chat']);

  const inputRef = useRef<HTMLTextAreaElement>(null);

  const [inputValue, setInputValue] = useState<string>('');
  const { rows, updateRows } = useRows({
    value: inputValue,
    textAreaRef: inputRef,
    compactMode: true,
  });

  const addSources = (newInputValue: string) => {
    if (sourceCount < MAX_CUSTOM_SOURCES) {
      const parsedLinks = parseLinks(newInputValue).slice(
        0,
        MAX_CUSTOM_SOURCES - sourceCount
      );
      handleAddWebsites(formatWebsiteInfo(parsedLinks));

      setInputValue('');
    }
  };

  return (
    <div className={styles.linkInputRoot}>
      <span className={styles.inputLabel}>
        {t('chat:trustedSources.modal.inputLabel')}
      </span>
      <div className={styles.inputWrapper}>
        <textarea
          className={styles.textareaElement}
          rows={rows}
          value={inputValue}
          ref={inputRef}
          onChange={e => {
            updateRows(e);
            setInputValue(e.target.value);
          }}
          onKeyUp={e => {
            e.stopPropagation();
          }}
          onKeyDown={e => {
            if (
              e.key === 'Enter' &&
              !e.shiftKey &&
              !e.nativeEvent.isComposing
            ) {
              e.preventDefault();
              addSources(inputValue);
            }
          }}
          disabled={false}
        />
        {inputValue && (
          <Button
            className={styles.styledButton}
            onClick={() => addSources(inputValue)}
            label={t('chat:trustedSources.modal.addToList')}
            variant="empty"
            size="small"
          />
        )}
      </div>
    </div>
  );
};
